import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';
import statementIcon from '../../../../assets/icons/price-tag.svg';
// import ruleIcon from '../../../../assets/icons/rules.svg';
// import settingIcon from '../../../../assets/icons/setting.svg';
// import logoutIcon from '../../../../assets/icons/logout.svg';
import { useTranslation } from 'react-i18next';
import LogoutHelper from '../../../../helpers/LogoutHelper';
// import right from '../../../../assets/icons/right.svg';
import upArrow from '../../../../assets/icons/uparrow.svg';
// import shoeIcon from '../../../../assets/icons/shoe.svg';
import { useDispatch } from 'react-redux';
import { playSong } from '../../actions/common.actions';
import { useSelector } from 'react-redux';
import { selectLoginData } from "../../../pages/login/login.actions";
import { FiHome } from 'react-icons/fi';
import { BiFootball } from 'react-icons/bi';
// import { PiCurrencyDollarSimpleBold } from "react-icons/pi";
import { GiRunningShoe } from "react-icons/gi";
// import { PiArrowLineUpRightBold } from "react-icons/pi";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { PiNewspaperClipping } from "react-icons/pi";
import { GoGear } from "react-icons/go";
import { RiLogoutBoxLine } from "react-icons/ri";

export const SideBarTwo = ({ setShowSideBar = () => {} }) => {
  const { t } = useTranslation();
  const { userDetails } = useSelector(selectLoginData);
  const sidebarRef = useRef(null);
  const dispatch = useDispatch();

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  useEffect(() => {
    const handleClick = (e) => {
      const clickedToggle = e.target?.closest?.('.toggle');
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(e.target) &&
        !clickedToggle
      ) {
        setShowSideBar(false);
      }
    };

    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, [setShowSideBar]);

  // useEffect(() => {
  //   const updateShowSidebar = () => {
  //     if (window.innerWidth < 640) {
  //       setShowSideBar(false);
  //       console.log('hide')
  //     } else {
  //       setShowSideBar(true);
  //       console.log('show');
  //     }
  //   };

  //   window.addEventListener('resize', updateShowSidebar);

  //   return () => {
  //     window.removeEventListener('resize', updateShowSidebar);
  //   };
  // }, []);

  const handleAccount = (e) => {
    // navigate(`/${e.target.id}`);
    handleSongClick();
    setShowSideBar(false);
  };

  // const handleLogOut = () => {
  //   localStorage.removeItem('token');
  //   setShowSideBar(false);
  // }
  return (
    <div className="w-full sm:w-[250px] absolute lg:bg-primary lg:static inset-0 h-[100dvh] duration-300 flex flex-col z-[1000]">
      <div
        ref={sidebarRef}
        className="w-[250px] sm:full flex flex-col h-[100dvh] absolute lg:static inset-0 z-[1000]"
      >
        {/* Scrollable Content Area */}
        <div className="relative flex-1 pt-6 pb-4 overflow-y-auto border-r-2 shadow-2xl bg-gradient-to-r from-black/5 to-black/20 backdrop-blur-xl border-black/20">

          {/* Logo Section */}
          <div className="relative z-10 px-6 mb-6">
            <Logo />
          </div>

          {/* Balance Display - Username and Balance */}
          <div className="relative z-10 px-3 py-3 mx-4 mb-6">
            <div className="flex items-center justify-between">
              {/* Username - Left */}
              <div className="text-left">
                <p className="text-xs text-white/70 font-bold uppercase tracking-wide mb-0.5">User</p>
                <span className="text-sm font-bold text-white">{userDetails?.username}</span>
              </div>

              {/* Balance - Right */}
              <div className="text-right">
                <p className="text-xs text-white/70 font-bold uppercase tracking-wide mb-0.5">Balance</p>
                <div className="flex items-baseline space-x-1">
                  <span className="text-sm font-bold text-white">
                    {parseInt(userDetails?.balance || 0).toLocaleString()} Ks
                  </span>
                  {/* <span className="text-xs font-bold text-golden">Ks</span> */}
                </div>
              </div>
            </div>
            {/* Luxury Border Accent - Same as Dashboard */}
            <div className="absolute bottom-0 left-0 right-0 h-1 shadow-lg bg-gradient-to-r from-crimson via-golden to-crimson"></div>
          </div>

          {/* Navigation Menu */}
          <nav className="px-4">
            <ul className="space-y-1">
              <li>
                <Link
                  to={"/dashboard"}
                  onClick={handleAccount}
                  className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                  <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                    <FiHome size={16} className="text-white" />
                  </div>
                  <span className="relative text-sm font-bold">Dashboard</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/account"
                  onClick={handleAccount}
                  className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                  <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                    <img src={statementIcon} alt="statement" className="w-4 h-4 filter brightness-0 invert" />
                  </div>
                  <span className="relative text-sm font-bold">{t('statement')}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/maungg"
                  onClick={handleAccount}
                  className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                  <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                    <GiRunningShoe size={16} className="text-white" />
                  </div>
                  <span className="relative text-sm font-bold uppercase">{t('maungg')}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/body"
                  onClick={handleAccount}
                  className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                  <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                    <BiFootball size={16} className="text-white" />
                  </div>
                  <span className="relative text-sm font-bold uppercase">{t('body')}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/selected-matches"
                  onClick={handleAccount}
                  className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                  <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                    <img src={upArrow} alt="upArrow" className="w-4 h-4 filter brightness-0 invert" />
                  </div>
                  <span className="relative text-sm font-bold uppercase">{t('selected')} {t('matches')}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/old-histories"
                  onClick={handleAccount}
                  className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                >
                  <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                  <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                    <IoCheckmarkDoneSharp size={16} className="text-white" />
                  </div>
                  <span className="relative text-sm font-bold uppercase">{t('oldHistories')}</span>
                </Link>
              </li>
              
              {/* Divider */}
              <li className="py-2">
                <div className="border-t border-crimson/20"></div>
              </li>

              <li>
                 <Link
                   to="/rules"
                   onClick={handleAccount}
                   className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                 >
                   <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                   <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                     <PiNewspaperClipping size={16} className="text-white" />
                   </div>
                   <span className="relative text-sm font-bold">{t('rule')}</span>
                 </Link>
               </li>
               <li>
                 <Link
                   to="/setting"
                   onClick={handleAccount}
                   className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                 >
                   <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                   <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                     <GoGear size={16} className="text-white" />
                   </div>
                   <span className="relative text-sm font-bold">Settings</span>
                 </Link>
               </li>
               { userDetails?.userId === 55 ?
               <li>
                 <Link
                   to={"/transactions"}
                   onClick={handleAccount}
                   className="relative flex items-center px-3 py-2.5 text-white rounded-xl hover:bg-crimson/5 hover:text-blue-dark transition-all duration-300 group overflow-hidden"
                   >
                   <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-crimson/5 via-golden/5 to-transparent group-hover:opacity-100"></div>
                   <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg shadow-md bg-gradient-to-br from-crimson via-red-primary to-crimson group-hover:scale-110 border-golden/40">
                     <RiLogoutBoxLine size={16} className="text-white transform rotate-180" />
                   </div>
                   <span className="relative text-sm font-bold">Transactions</span>
                 </Link>
               </li> : null
               }
            </ul>
          </nav>
        </div>
          
        {/* Fixed Footer Section with Logout */}
        <div className="relative flex-shrink-0 bg-gradient-to-r from-black/5 to-black/20 backdrop-blur-xl">
          {/* Luxury Border Accent - Same as Dashboard */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-crimson via-golden to-crimson"></div>
          <div className="p-4 pt-5">
            <Link
              to="/"
              onClick={(e) => {
                e.preventDefault();
                setShowSideBar(false);
                LogoutHelper();
              }}
              className="relative flex items-center justify-center w-full px-4 py-3 overflow-hidden text-white transition-all duration-300 border-2 shadow-lg bg-gradient-to-br from-crimson via-red-primary to-crimson border-golden rounded-xl hover:shadow-xl group"
            >
              <div className="absolute inset-0 transition-all duration-300 bg-gradient-to-br from-white/10 via-golden/10 to-transparent group-hover:from-white/20 group-hover:via-golden/20"></div>
              <div className="relative flex items-center justify-center w-8 h-8 mr-3 transition-transform duration-300 border rounded-lg bg-gradient-to-br from-red-dark via-crimson to-red-dark group-hover:scale-110 border-golden/40">
                <RiLogoutBoxLine size={16} className="text-white" />
              </div>
              <span className="relative text-sm font-bold drop-shadow-lg">Logout</span>
            </Link>
          </div>
        </div>
      </div>
      <div onClick={() => setShowSideBar(false)} className="w-full sm:w-0 h-[100dvh] absolute bg-primary/[0.1] z-[900] right-0" />
    </div>
  );
};
